import React, { useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import StrategyDeskPage from '../../strategyDesk/StrategyDeskPage';
import StrategyPerformancePage from '../../strategyPerformance/StrategyPerformancePage';
import StrategyTelemetryPage from '../../strategyTelemetry/StrategyTelemetryPage';
import { shellTokens } from '../theme/shellTheme';

const STRATEGY_TABS = [
    { value: 'fleet', label: 'Fleet overview' },
    { value: 'telemetry', label: 'Telemetry' },
    { value: 'analytics', label: 'Analytics' },
];

const subTabSx = (active) => ({
    border: `1px solid ${active ? 'rgba(37, 99, 235, 0.25)' : shellTokens.border}`,
    bgcolor: active ? 'rgba(37, 99, 235, 0.1)' : shellTokens.surface,
    borderRadius: '8px',
    px: 1.75,
    py: 0.85,
    fontSize: '0.78rem',
    fontWeight: 700,
    color: active ? shellTokens.primary : shellTokens.muted,
    textTransform: 'none',
});

const StrategiesPage = () => {
    const [activeTab, setActiveTab] = useState('fleet');

    return (
        <Box>
            <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mb: 1.75 }}>
                {STRATEGY_TABS.map((tab) => (
                    <Button
                        key={tab.value}
                        sx={subTabSx(activeTab === tab.value)}
                        onClick={() => setActiveTab(tab.value)}
                    >
                        {tab.label}
                    </Button>
                ))}
            </Stack>

            {activeTab === 'fleet' ? <StrategyDeskPage /> : null}
            {activeTab === 'telemetry' ? <StrategyTelemetryPage /> : null}
            {activeTab === 'analytics' ? <StrategyPerformancePage /> : null}
        </Box>
    );
};

export default StrategiesPage;
